import React, { useEffect, useState } from 'react'
import { Button, Card, Checkbox, Col, Form, Icon, Input, message, Row, Spin } from 'antd';
import { connect } from 'react-redux'
import AuditVoucherSearch from '../../components/AuditVoucherSearch'
import { getASTAssetsBuAuditVocher } from '../../appRedux/actions';

export const Reconcilation = (props) => {
    const [voucher, setVoucher] = useState(null);

    // useEffect(() => {
    //     console.log(props.astAssets);
    // }, [props.astAssets]);

    const fetchAssetsFromAST = () => {
        if (voucher)
            props.getASTAssetsBuAuditVocher(voucher);
    }

    const selectVoucherHandle = (v) => {
        if (v)
            setVoucher(v)

    }
    return (
        <div>
            <Spin spinning={false}>
                <Card className={`gx-card-metrics`} title={`AST Reconcilation`}>


                    <Row gutter={8}>
                        <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                            <AuditVoucherSearch
                                styleName="gx-lt-icon-search-bar-lg"
                                placeholder="Search Audit Voucher..."
                                onSelect={(value) => selectVoucherHandle(value)}
                                authUser={props.authUser}
                                defaultAsset={props.data && props.data.auditVoucher}
                            />
                        </Col>
                    </Row>


                    <Button type="primary" htmlType="submit" loading={props.loading} onClick={fetchAssetsFromAST}>
                        Generate Report
                    </Button>



                </Card>

            </Spin>
        </div>
    )
}

const mapStateToProps = ({ assetStockTaking }) => ({
    astAssets: assetStockTaking.auditVoucherASTAssets
})

const mapDispatchToProps = { getASTAssetsBuAuditVocher }

export default connect(mapStateToProps, mapDispatchToProps)(Reconcilation)